import {Divider, Grid, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import AppList from 'main/core/AppList';
import PropTypes from 'prop-types';
import DyelotCell from './DyelotCell';

const DyelotAlert = ({title, color, data}) => {
  return (
    <Grid item xs={12} md={4}>
      <Box sx={{mb: 4}}>
        <Typography
          sx={{color: color, fontWeight: 'bold', fontSize: 14, mb: 1}}
        >
          {title}
        </Typography>
        <Divider
          sx={{borderBottomWidth: 2, borderColor: color, opacity: 0.3}}
        />
      </Box>

      <AppList
        data={data}
        renderRow={(item, index) => (
          <DyelotCell item={item} key={index} bgColor={color} />
        )}
      />
    </Grid>
  );
};

DyelotAlert.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  data: PropTypes.array,
};

export default DyelotAlert;
